import React, { useState, useEffect } from 'react';
import { extractWorkbookV2, extraerJsonConDatos } from '../../../sharecomponents/ExcelUtilities';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import vr from '../../../../utils/Verifiers';
import TableHeadsData from '../../nomina/InventarioActividadesComponents/tableHeadsData';

const CargaLaboresExcel = () => {
    const [excelData, setexcelData] = useState({ workbook: undefined, hojas: [], hoja: "" });
    const [registros, setregistros] = useState([]);
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const encabezados = [
        "Actividad",
        "Espacio",
        "Flor",
        "Varidad",
        "Color",
        "Union de Textos",
        "Nombre de la actividad",
        "Cuantas veces se realiza",
        "inventario que se utiliza",
        "semana asociada",
        "Tiempo antes o despues de la semana asociada",
        "pago por unidad",
        "unidades hora",
        "unidad"
    ];
    const [encabezadosTabla, setencabezzadosTabla] = useState([]);
    useEffect(() => {

    }, []);

    const extraerTitulosDatosExcel = (arrayJson) => {
        const upperEncabezados = encabezados.map((enc) => enc.toUpperCase().trim());
        const lenEncabezados = upperEncabezados.length;
        const hash = {};
        upperEncabezados.forEach((enc) => {
            hash[enc] = -1;
        });
        const len = arrayJson.length;

        for (let i = 0; i < len; i++) {
            const fila = arrayJson[i];
            const lenFila = fila.length;

            if (lenFila < lenEncabezados) continue;
            const hashCopia = { ...hash };

            for (let j = 0; j < lenFila; j++) {
                const celda = `${fila[j] ?? ''}`.toUpperCase().trim();
                if (hashCopia[celda] === undefined) break;
                hashCopia[celda] = j;
            }
            let encontradosCount = Object.values(hashCopia).filter((v) => v !== -1).length;
            if (encontradosCount === lenEncabezados) {
                return {
                    encabezados: hashCopia,
                    data: arrayJson.slice(i + 1, len)
                }
            }
        }
        return {
            encabezados: {},
            data: []
        }
    }

    const limpiezaDatosProcesados = (datos) => {

        const len = datos.length;
        for (let i = 0; i < len; i++) {
            const actividad_principal = datos[i].ACTIVIDAD.replace('-', '').replace(/\s+/g, ' ').trim().toUpperCase();
            const actividad_secundaria = (datos[i].ESPACIO ?? '').replace('-', '').replace(/\s+/g, ' ').trim().toUpperCase();
            let nombre_actividad = actividad_principal;
            if (actividad_secundaria !== '') {
                nombre_actividad = ` ${nombre_actividad} ${actividad_secundaria}`;
            }


            if (!datos[i].VARIEDAD && datos[i].VARIDAD) {
                datos[i].VARIEDAD = datos[i].VARIDAD;
                delete datos[i].VARIDAD;
            }

            datos[i].VARIEDAD = (`${datos[i].VARIEDAD ?? ''}`).replace(/\s+/g, ' ').trim().toUpperCase();
            datos[i].FLOR = (`${datos[i].FLOR ?? ''}`).replace(/\s+/g, ' ').trim().toUpperCase();
            datos[i].COLOR = (`${datos[i].COLOR ?? ''}`).replace(/\s+/g, ' ').trim().toUpperCase();
            datos[i].ACTIVIDAD = `${nombre_actividad} - ${datos[i].FLOR ?? ''} ${datos[i].VARIEDAD ?? ''} ${datos[i].COLOR ?? ''}`
                .toUpperCase().replace(/\s+/g, ' ').trim();

            datos[i].INVENTARIO = (`${datos[i]['INVENTARIO QUE SE UTILIZA'] ?? ''}`).replace(/\s+/g, ' ').trim().toUpperCase();
            delete datos[i]['INVENTARIO QUE SE UTILIZA'];

            delete datos[i]['UNION DE TEXTOS'];
            delete datos[i]['NOMBRE DE LA ACTIVIDAD'];
            delete datos[i].ESPACIO;

            datos[i].PAGO_UNIDAD = parseFloat(`${datos[i]['PAGO POR UNIDAD'] ?? '0'}`) || 0;
            delete datos[i]['PAGO POR UNIDAD'];

            datos[i].SEMANA = (`${datos[i]['SEMANA ASOCIADA'] ?? ''}`).replace(/\s+/g, ' ').trim().toUpperCase();
            delete datos[i]['SEMANA ASOCIADA'];

            datos[i].REFERENCIA = (`${datos[i]['TIEMPO ANTES O DESPUES DE LA SEMANA ASOCIADA'] ?? ''}`).replace(/\s+/g, ' ').trim().toUpperCase();
            delete datos[i]['TIEMPO ANTES O DESPUES DE LA SEMANA ASOCIADA'];

            datos[i].UNIDAD = (`${datos[i]['UNIDAD'] ?? ''}`).replace(/\s+/g, ' ').trim().toUpperCase();
            datos[i].UNIDAD_HORA = parseFloat(`${datos[i]['UNIDADES HORA'] ?? '0'}`) || 0;
            delete datos[i]['UNIDADES HORA'];

            let realiza = `${datos[i]['CUANTAS VECES SE REALIZA'] ?? ''}`.toLowerCase();
            if (realiza.includes('x semana')) {
                let veces = realiza.replace('x semana', '').trim();
                datos[i].FRECUENCIA_SEMANA = parseInt(veces) || 0;
                datos[i].FRECUENCIA_DIA = 1;
                datos[i].FRECUENCIA_UNICA = 'NO';
            } else if (realiza.includes('veces al dia')) {
                let veces = realiza.replace('veces al dia', '').trim();
                veces = parseInt(veces) || 0;
                datos[i].FRECUENCIA_DIA = veces;
                datos[i].FRECUENCIA_SEMANA = 7;
                datos[i].FRECUENCIA_UNICA = 'NO';
            } else {
                datos[i].FRECUENCIA_SEMANA = 1;
                datos[i].FRECUENCIA_DIA = 1;
                datos[i].FRECUENCIA_UNICA = 'SI';
            }
            delete datos[i]['CUANTAS VECES SE REALIZA'];
        }

        datos.sort((a, b) => { return a.ACTIVIDAD.localeCompare(b.ACTIVIDAD); });
        datos.sort((a, b) => { return a.COLOR.localeCompare(b.COLOR); });
        datos.sort((a, b) => { return a.VARIEDAD.localeCompare(b.VARIEDAD); });
        datos.sort((a, b) => { return a.FLOR.localeCompare(b.FLOR); });
        return datos;
    }

    const procesarDatos = (jsonArray) => {
        const { encabezados, data } = extraerTitulosDatosExcel(jsonArray);
        const encabezadosNombres = Object.keys(encabezados);
        let jsonProcesados = [];
        data.forEach(fila => {
            const registro = {};
            encabezadosNombres.forEach((nombre, index) => {
                registro[nombre] = fila[index] ?? null;
            });
            jsonProcesados.push(registro);
        });
        jsonProcesados = limpiezaDatosProcesados(jsonProcesados);

        if (jsonProcesados.length > 0) {
            // const encabezadosTabla = Object.keys(jsonProcesados[0]);
            setencabezzadosTabla([
                'FLOR',
                'VARIEDAD',
                'COLOR',
                'ACTIVIDAD',
                'UNIDAD',
                'UNIDAD_HORA',
                'PAGO_UNIDAD',
                'INVENTARIO',
                'SEMANA',
                'FRECUENCIA_UNICA',
                'FRECUENCIA_DIA',
                'FRECUENCIA_SEMANA',
                'REFERENCIA',
            ]);
            setregistros(jsonProcesados);
        } else {
            setencabezzadosTabla([]);
            setregistros([]);
        }
    }

    const loadsheet = async (e) => {
        let hoja = e.target.value;
        setloader(true);
        setexcelData({ ...excelData, hoja: hoja });
        const response = await extraerJsonConDatos(excelData.workbook, hoja);
        setloader(false);
        procesarDatos(response.data);
    }

    const loadWorbook = async (e) => {
        setloader(true);
        const resp = await extractWorkbookV2(e);
        setloader(false);
        if (!resp.estatus) {
            vr.activeDialog(setdialog, resp.msj, 'Ocurrió un problema', 'error');
            return;
        }
        setexcelData({ ...excelData, workbook: resp.data.workbook, hojas: resp.data.hojas });
    }

    const guardarRegistros = async () => {
        const resp = await vr.getDataAPI("ordenes_trabajo/labores/importar/excel", { actividades: registros }, setloader, setdialog);
        if (!resp) return;
        vr.activeDialog(setdialog, resp.msj, resp.estatus ? 'Operación exitosa' : "Error en la operación", resp.estatus ? 'success' : "error");
        console.log(resp);
    }

    const crearAsociaciones = async () => {
        const resp = await vr.getDataAPI("ordenes_trabajo/labores/importar/asociar", {}, setloader, setdialog);
        if (!resp) return;
        vr.activeDialog(setdialog, resp.msj, resp.estatus ? 'Operación exitosa' : "Error en la operación", resp.estatus ? 'success' : "error");
    }

    return (
        <>
            <div className="dosis" style={{ width: '100%', height: 'calc(100vh - 190px)' }}>
                <div className={`row m-0 p-0 justify-content-center`}>

                    <div className="bw contenedor-bottom mt-2" style={{ '--bw': '250px' }}>
                        <button className='btn btn-sm border-2 text-boldbtn-light shadow w-100 border border-warning'
                            onClick={crearAsociaciones}>Asociar registros existentes</button>
                    </div>
                    <div className='form-group mt-2' style={{ width: '300px' }}>
                        <label className="text-success text-bold  nowrap">Seleccionar archivo excel</label>
                        <input type='file' className='form-control form-control-sm' onChange={loadWorbook}
                            placeholder='Cargar archivo'
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                    </div>

                    <div className='form-group mt-2' style={{ width: '250px' }}>
                        {excelData.hojas && excelData.hojas.length > 0 && <>
                            <label className="text-success text-bold  nowrap">Seleccionar hoja</label>
                            <select className='form-control form-control-sm' placeholder='' value={(excelData.hoja ?? "")} onChange={loadsheet}>
                                <option value='' >Seleccione una</option>
                                {
                                    excelData.hojas.map((hoja) => {
                                        return (
                                            <option key={"hoja" + hoja} value={hoja}>{hoja}</option>
                                        )
                                    })
                                }
                            </select>
                        </>
                        }
                    </div>
                    <div className="bw text-center contenedor-bottom mt-2" style={{ '--bw': '200px' }}>
                        {registros.length > 0 && <button className='btn btn-success shadow w-100' style={{ borderRadius: 0 }} onClick={guardarRegistros}>Guardar registros</button>}
                    </div>
                    <div className="w mb-5" style={{ '--w': '100%' }} />
                    {registros.length === 0 && <div className="w h5 text-300 text-center text-danger" style={{ '--w': '100%' }}>ESTA ES UNA SECCIÓN EN CONSTRUCCIÓN</div>}
                    {registros.length > 0 && <>
                        <div className="w h5 text-300 text-center text-danger" style={{ '--w': '100%' }}>Vista previa, se muestran hasta 1000 registros del total de {registros.length} encontrados</div>
                        <TableHeadsData data={registros.slice(0, 1000)} heads={encabezadosTabla} styleName={{ width: '100% !important', height: 'calc(73vh - 30px)', overflow: "auto" }} classN={"w-100"} />
                    </>}
                </div>
                <VainillaDialog dialog={dialog} />
            </div>
            {loader && ldr}
        </>
    )
}

export default CargaLaboresExcel;